<script>
import { mapGetters } from 'vuex';

import AccountantConnectionService from "@/store/services/accountants.service.js";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsAccountants",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_ACCOUNTANTS'
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId',
    }),
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = this.getCompanyId;
        }

        AccountantConnectionService.getAccountantTotals(this.filters).then((response) => {
          this.amountsList = []
          this.amountsList.push({text: this.$gettext("PENDING"), amount: response.data.number_of_pending_invites, class:'text-brand'})
          this.amountsList.push({text: this.$gettext("DISCONNECTED"), amount: response.data.number_of_disconnected_companies, class:'text-blue'})
          this.amountsList.push({text: this.$gettext("CONNECTED"), amount: response.data.number_of_connected_companies, class:''})
          this.loading = false
        })
      }
    }
  }
};
</script>